import { Viewport } from "../pixel-accessor";
import type { ReversePixelMapper } from "./ReversePixelMapper";
import { isReversePixelMapper } from "./ReversePixelMapper";

export interface BestFitReversePixelMapper extends ReversePixelMapper {
  /**
   * Flags that distortion forces best fit for its performing.
   */
  readonly forceBestFit?: boolean;

  /**
   * Returns calculated best-fit viewport for given source image viewport.
   *
   * @param viewport Source image viewport.
   */
  getBestFitViewport(viewport: Viewport): Viewport;
}

/**
 * Checks if passed object implements BestFitReversePixelMapper interface.
 *
 * @param obj
 */
export function isBestFitReversePixelMapper(
  obj: unknown
): obj is BestFitReversePixelMapper {
  type C = Partial<BestFitReversePixelMapper>;
  return (
    isReversePixelMapper(obj) &&
    typeof (obj as C).getBestFitViewport === "function"
  );
}
